import { render, staticRenderFns } from "./edit-email-template.vue?vue&type=template&id=db0587f0"
import script from "./edit-email-template.vue?vue&type=script&lang=js"
export * from "./edit-email-template.vue?vue&type=script&lang=js"
import style0 from "./edit-email-template.vue?vue&type=style&index=0&id=db0587f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports